import React, { useState } from 'react';
import { Modal, Flex, Col, Row, Button } from 'antd';
import { CopyOutlined, MailOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

export const SendAppModal = ({ onSendApp, isApplicationOpen, toggleApplication }) => {
  const { selectedLead } = useSelector((state) => state.spot);
  const [method, setMethod] = useState('email');

  const handleTypeApp = async () => {
    await onSendApp({ lead: selectedLead, sendToEmail: method === 'email' });
  };

  return (
    <Modal
      open={isApplicationOpen}
      onCancel={toggleApplication}
      title="Choose how to send the application"
      footer={[
        <Button onClick={toggleApplication}>Cancel</Button>,
        <Button onClick={handleTypeApp} type="primary">
          {method === 'email' ? 'Send App' : 'Copy App'}
        </Button>,
      ]}>
      <Row align="center" justify="between" gutter={16}>
        <Col span={12}>
          <SelectionCard
            Icon={MailOutlined}
            value="email"
            label={`Send application directly to ${selectedLead?.email || 'lead email'}`}
            onClick={() => setMethod('email')}
            selected={method}
          />
        </Col>
        <Col span={12}>
          <SelectionCard
            Icon={CopyOutlined}
            value="copy"
            label="Copy application to your clipboard"
            onClick={() => setMethod('copy')}
            selected={method}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export const SelectionCard = ({ label, Icon, onClick, value, selected }) => {
  return (
    <button
      onClick={onClick}
      value={value}
      style={{
        width: '100%',
        fontWeight: 'bold',
        border: `1px solid ${selected === value ? '#00506c' : '#d9d9d9'}`,
        color: `${selected === value ? '#00506c' : '#4d4d4d'}`,
        padding: '1.5rem',
        borderRadius: '.5rem',
        height: '150px',
        background: selected === value ? '#f9fdff' : '',
      }}>
      <Flex vertical align="center" gap={8}>
        {Icon && <Icon style={{ fontSize: '1rem' }} />}
        <p>{label}</p>
      </Flex>
    </button>
  );
};
